import React from 'react'

import { Tooltip as Component } from './Tooltip'

const Tooltip = props => {
  return <Component {...props} />
}
export default Tooltip
